import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import styled from "styled-components";
import {RiAccountCircleFill} from "react-icons/ri";
import multiavatar from "@multiavatar/multiavatar/esm";

const Profile = ({user}) => {

    return (
        <Container>
            <div style={{paddingTop: 20}}>
                <div className='header'>
                    <h3>My Profile</h3>
                </div>
            </div>
            <div className='avatar-container'>
                {
                    user.avatarImage ?
                        <div className='avatar'
                             dangerouslySetInnerHTML={{__html: multiavatar(user.avatarImage)}}>
                        </div>
                        :
                        <RiAccountCircleFill className='avatar-icon'/>
                }
                <h4>{user.name}</h4>
            </div>
            <div className='status-container'>
                <p>{user.status}</p>
            </div>
            <div className='profile-container'>
                <div>
                    <label className="label">Name</label>
                    <h4>{user.name}</h4>
                </div>
                <div>
                    <label className="label">Email</label>
                    <h4>{user.email}</h4>
                </div>
                <div>
                    <label className="label">Mobile Number</label>
                    <h4>{user.phone}</h4>
                </div>
                <div>
                    <label className="label">Birthdate</label>
                    <h4>{user.birthDate}</h4>
                </div>
                <div>
                    <label className="label">Location</label>
                    <h4>{user.location}</h4>
                </div>
            </div>

        </Container>

    );
}

Profile.propTypes = {
    user: PropTypes.object,
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
});

export default connect(mapStateToProps)(Profile);

const Container = styled.div`
  background-color: #F5F7FB;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0px 24px;
  border-left: #ECEDF6 solid 2px;
  border-right: #ECEDF6 solid 2px;
  overflow-y: auto;

  @media screen and (max-width: 1000px) {
    .header {
      margin-top: 59px;
    }
  }
  
  &::-webkit-scrollbar {
    width: 0.2rem;

    &-thumb {
      background-color: #D1D6DB;
      width: 0.1rem;
      border-radius: 1rem;
    }
  }
  
  .header {
    padding-top: 12px;
    padding-bottom: 24px;
  }
  
  .avatar-container{
    text-align: center;
    border-bottom: #F0EFF5 1px solid;
    padding-bottom: 35px;

    .avatar {
      width: 5rem;
      padding-bottom: 15px;
      display: inline-block;
     }

    .avatar-icon {
      font-size: 6rem;
      padding-bottom: 15px;
    }
    
    h4{
      font-weight: 500;
    }
  }

  .status-container{
    padding: 35px 0;
    
    p{
      font-size: 0.9rem;
      color: #7A7FB3;
    }
  }

  .profile-container{
    background-color: white;
    padding: 20px 20px;
    font-size: 0.9rem;
    
    div{
      padding-bottom: 25px;  
    }
    
    div:last-child{
      padding-bottom: 0;
    }
    
    .label {
      display: block;
      margin-bottom: 0.3rem;
      color: #7A7FB3;
    }

    h4{
      font-weight: 500;
    }
  }
`;